import React, { useEffect, useRef } from 'react';

import { IPlansList20Fields } from '../../../types/contentful';

import { CollapsiblePlanInfo } from './CollapsiblePlanInfo';
import { BlockContainer, Column, Layout } from '../Layout';
import { Text } from '../Text';

interface Props extends IPlansList20Fields {
  sysId?: string;
}

export function CollapsiblePlansList({ plans, heading, sysId }: Props) {
  const collapsiblePlanRefs = useRef<Array<HTMLDivElement | null>>([]);

  useEffect(() => {
    const setMinHeight = () => {
      collapsiblePlanRefs.current.forEach((ref) => {
        ref!.style.minHeight = 'fit-content';
      });
      const maxHeight =
        Math.max(
          ...collapsiblePlanRefs.current.map((ref) => ref?.clientHeight || 0)
        ) + 'px';

      collapsiblePlanRefs.current.forEach((ref) => {
        if (ref) ref.style.minHeight = maxHeight;
      });
    };

    setMinHeight();

    window.addEventListener('resize', setMinHeight);
    return () => window.removeEventListener('resize', setMinHeight);
  }, [plans]);

  return (
    <BlockContainer
      marginTop={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      marginBottom={{ 0: 'blockMarginY', tablet: 'blockMarginY_tablet' }}
      data-blockid={sysId}
      data-eltype="collapsible-plans-list"
      data-testid="collapsiblePlansList"
    >
      <Layout>
        {!!heading && (
          <Column size={{ 0: 11 }} marginBottom="l" justifyContent="center">
            <Text
              as="h2"
              fontWeight="h2"
              data-elementid="collapsible-plans-heading"
              textAlign="center"
              colour="defaultText"
              fontSize={{
                0: 'h2_0',
                tablet: 'h2_tablet',
                desktop: 'h2_desktop'
              }}
            >
              {heading || ''}
            </Text>
          </Column>
        )}
        <div className="grid auto-rows-max small:grid-cols-1 small:gap-4 small:!px-6 tablet:grid-cols-3 tablet:gap-8">
          {(plans || []).map(({ sys, fields }, index) => (
            <CollapsiblePlanInfo
              ref={(el) => { collapsiblePlanRefs.current[index] = el; }}
              key={sys?.id}
              {...fields}
            />
          ))}
        </div>
      </Layout>
    </BlockContainer>
  );
}
